
<template>
  <div>
    <div class="pageHeadding d-flex align-center justify-center">
      Key findings
    </div>
    <v-layout>
      <v-flex xs12 sm6 md4>
        <div class="col1 divWidth">
          <v-card flat class="heading d-flex align-center justify-center">
            <div class="categoryContent">Solar</div>
          </v-card>

          <v-card-title class="d-flex align-center justify-center">
            <div class="content content-1">{{ keyfindingsdata.solar == 0 ? "0.00" : keyfindingsdata.solar  }} MW</div>
          </v-card-title>

          <v-card flat class="heading r2 d-flex align-center justify-center">
            <div class="categoryContent">Storage</div>
          </v-card>

          <v-card-title class="d-flex align-center justify-center">
            <div class="content content-1">
              {{ `${keyfindingsdata.storageMWh == 0 ? "0.00" : keyfindingsdata.storageMWh} MWh` }}
            </div>
          </v-card-title>

          <v-card flat class="heading r3 d-flex align-center justify-center">
            <div class="categoryContent">Storage</div>
          </v-card>

          <v-card-title class="d-flex align-center justify-center">
            <div class="content content-1">
              {{ `${keyfindingsdata.storageMW == 0 ? "0.00" : keyfindingsdata.storageMW } MW` }}
            </div>
          </v-card-title>
        </div>
      </v-flex>
      <v-flex xs12 offset-sm6 md4 ml-2>
        <div class="col2 divWidth">
          <v-card flat class="heading r4 d-flex align-center justify-center">
            <div class="categoryContent">From solar</div>
          </v-card>

          <v-card-title class="d-flex align-center justify-center">
            <div class="content content-1">
              {{ keyfindingsdata.fromSolarPercent == 0 ? "0.00" : keyfindingsdata.fromSolarPercent }} %
            </div>
          </v-card-title>

          <v-card flat class="heading r5 d-flex align-center justify-center">
            <div class="categoryContent">From storage</div>
          </v-card>

          <v-card-title class="d-flex align-center justify-center">
            <div class="content content-1">
              {{ keyfindingsdata.fromStoragePercent == 0 ? "0.00" :  keyfindingsdata.fromStoragePercent }} %
            </div>
          </v-card-title>

          <v-card flat class="heading r6 d-flex align-center justify-center">
            <div class="categoryContent">From grid</div>
          </v-card>

          <v-card-title class="d-flex align-center justify-center">
            <div class="content content-1">
              {{ keyfindingsdata.fromGridPercent == 0 ? "0.00" : keyfindingsdata.fromGridPercent }} %
            </div>
          </v-card-title>
        </div>
      </v-flex>
      <v-flex xs12 sm6 md4 ml-2>
        <div class="col3 divWidth">
          <v-card flat class="heading r7 d-flex align-center justify-center">
            <div class="categoryContent">Voltage violations</div>
          </v-card>

          <v-card-title class="d-flex align-center justify-center">
            <div class="content content-1">
              {{ keyfindingsdata.voltageViolationPercent == 0 ? "0.00" : keyfindingsdata.voltageViolationPercent }} %
            </div>
          </v-card-title>

          <v-card flat class="heading r8 d-flex align-center justify-center">
            <div class="categoryContent">Distribution loss</div>
          </v-card>

          <v-card-title class="d-flex align-center justify-center">
            <div class="content content-1">
              {{ keyfindingsdata.distributionLossesPercent == 0 ? "0.00" : keyfindingsdata.distributionLossesPercent }} %
            </div>
          </v-card-title>

          <v-card flat class="heading r9 d-flex align-center justify-center">
            <div class="categoryContent">Transmission loss</div>
          </v-card>

          <v-card-title class="d-flex align-center justify-center">
            <div class="content content-1">
              {{ keyfindingsdata.transmissionLossesPercent == 0 ? "0.00" : keyfindingsdata.transmissionLossesPercent }} %
            </div>
          </v-card-title>
        </div>
      </v-flex>
      <v-flex xs12 sm6 md4 ml-2>
        <div class="col4 divWidth">
          <v-card flat class="heading r10 d-flex align-center justify-center">
            <div class="categoryContent">Network value</div>
          </v-card>

          <v-card-title class="d-flex align-center justify-center">
            <div class="content content-1">
              {{ keyfindingsdata.networkBenefits == 0 ? "0.00" : keyfindingsdata.networkBenefits }} INR/kWh
            </div>
          </v-card-title>

          <v-card flat class="heading r11 d-flex align-center justify-center">
            <div class="categoryContent">S&E value</div>
          </v-card>

          <v-card-title class="d-flex align-center justify-center">
            <div class="content content-1">
              {{ keyfindingsdata.societalBenefits == 0 ? "0.00" : keyfindingsdata.societalBenefits }} INR/kWh
            </div>
          </v-card-title>

          <v-card flat class="heading r12 d-flex align-center justify-center">
            <div class="categoryContent">Total value</div>
          </v-card>

          <v-card-title class="d-flex align-center justify-center">
            <div class="content content-1">
              {{ keyfindingsdata.totalBenefits == 0 ? "0.00" : keyfindingsdata.totalBenefits }} INR/kWh
            </div>
          </v-card-title>
        </div>
      </v-flex>
    </v-layout>
    <!-- <v-layout class="solcialMediaBar text-xs-center">
      <v-flex xs12 sm6 md4>
          <div class="solcialMediaMenu">
            <v-card flat class="d-flex align-center justify-center">
              <v-icon @click="openFacebookApp" x-large>mdi-facebook</v-icon>
            </v-card>
          </div>
        </v-flex>

        <v-flex xs12 sm6 md4>
          <div class="solcialMediaMenu">
            <v-card flat class="d-flex align-center justify-center">
              <v-icon @click="openInstaApp" x-large>mdi-instagram</v-icon>
            </v-card>
          </div>
        </v-flex>

        <v-flex xs12 sm6 md4>
          <div class="solcialMediaMenu">
            <v-card flat class="d-flex align-center justify-center">
              <v-icon @click="openLinkedinApp" x-large>mdi-linkedin</v-icon>
            </v-card>
          </div>
        </v-flex>
    
    </v-layout> -->
    <div
      class="mt-5 pageHeadding d-flex align-center justify-center"
      style="margin: 0 5px"
    >
      <v-card
        outlined
        flat
        class="d-flex align-center justify-center menu-border"
       >
        <v-icon @click="openFacebookApp" x-large>mdi-facebook</v-icon>
      </v-card>

      <v-card
        outlined
        flat
        class="d-flex align-center justify-center  menu-border"
        >
        <v-icon @click="openInstaApp" x-large>mdi-twitter</v-icon>
      </v-card>

      <v-card
        outlined
        flat
        class="d-flex align-center justify-center  menu-border"
      >
        <v-icon @click="openLinkedinApp" x-large>mdi-linkedin</v-icon>
      </v-card>
    </div>
    <v-spacer></v-spacer>

    <div id="fb-root"></div>
    <v-card v-if="false" flat outlined class="mx-auto">
      <v-card-title> Key findings </v-card-title>
      <v-card-text>
        <v-row>
          <!-- header -->
          <v-col>
            <div class="text-darken-1">
              <v-icon x-large>mdi-gift</v-icon>
            </div>
          </v-col>

          <v-col></v-col>
          <v-col>
            <div class="text-darken-1" style="min-width: 150px">
              <v-icon x-large>mdi-gift</v-icon>
            </div>
          </v-col>
          <v-col></v-col>
          <v-col>
            <div class="text-darken-1" style="min-width: 150px">
              <v-icon x-large>mdi-gift</v-icon>
            </div>
          </v-col>
          <v-col></v-col>
          <v-col>
            <div class="text-darken-1">
              <v-icon x-large>mdi-gift</v-icon>
            </div>
          </v-col>
          <v-col></v-col>
          <v-col></v-col>
        </v-row>
        <!-- value -->
        <v-row>
          <v-col>
            <div class="text-darken-1">Solar</div>
          </v-col>

          <v-col fluid>{{ keyfindingsdata.solar }} MW</v-col>
          <v-col>
            <div class="text-darken-1" style="min-width: 150px">
              Network Benefits
            </div>
          </v-col>
          <v-col fluid>
            <div style="min-width: 100px">
              {{ keyfindingsdata.networkBenefits }} INR/kWh
            </div></v-col
          >
          <v-col>
            <div class="text-darken-1" style="min-width: 180px">
              Voltage Violation
            </div>
          </v-col>
          <v-col fluid> {{ keyfindingsdata.voltageViolationPercent }} %</v-col>

          <v-col>
            <div class="text-darken-1">From Solar</div>
          </v-col>
          <v-col fluid> {{ keyfindingsdata.fromSolarPercent }} %</v-col>

          <v-col>
            <div class="text-darken-1">
              <v-icon @click="openFacebookApp" x-large>mdi-facebook</v-icon>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div class="text-darken-1">Storage</div>
          </v-col>

          <v-col> {{ `${keyfindingsdata.storageMWh} MWh` }} </v-col>
          <v-col>
            <div class="text-darken-1" style="min-width: 150px">
              Societal Benefits
            </div>
          </v-col>
          <v-col>
            <div style="min-width: 100px">
              {{ keyfindingsdata.societalBenefits }} INR/kWh
            </div></v-col
          >
          <v-col>
            <div class="text-darken-1" style="min-width: 180px">
              Distribution Losses
            </div>
          </v-col>
          <v-col>{{ keyfindingsdata.distributionLossesPercent }} %</v-col>
          <v-col>
            <div class="text-darken-1">From Storage</div>
          </v-col>
          <v-col>{{ keyfindingsdata.fromStoragePercent }} %</v-col>
          <v-col>
            <div class="text-darken-1">
              <v-icon @click="openInstaApp" x-large>mdi-twitter</v-icon>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div class="text-darken-1">Storage</div>
          </v-col>

          <v-col>{{ keyfindingsdata.storageMW }} MW</v-col>
          <v-col>
            <div class="text-darken-1" style="min-width: 150px">
              Total Benefits
            </div>
          </v-col>
          <v-col
            ><div style="min-width: 100px">
              {{ keyfindingsdata.totalBenefits }} INR/kWh
            </div></v-col
          >
          <v-col>
            <div class="text-darken-1" style="min-width: 180px">
              Transmission Losses
            </div>
          </v-col>
          <v-col>{{ keyfindingsdata.transmissionLossesPercent }} %</v-col>
          <v-col>
            <div class="text-darken-1">From Grid</div>
          </v-col>
          <v-col>{{ keyfindingsdata.fromGridPercent }} %</v-col>
          <v-col>
            <div class="text-darken-1">
              <v-icon @click="openLinkedinApp" x-large>mdi-linkedin</v-icon>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import VueMeta from 'vue-meta'
export default {
  name: "keyfindings",
  props: ["keyfindingsdata", "id","reportImage"],

  metaInfo () {
    return {
      title: 'Solva - Rock',
      titleTemplate: `%s - report final`,
      meta: [
        {name: 'viewport', content: 'user-scalable=no'},
        // {property: 'og:title', content: 'title'},
        {property: 'og:type', content: 'article'},
        // {property: 'og:url', content: 'http://www.nytimes.com/2015/02/19/arts/international/when-great-minds-dont-think-alike.html'},
        {property: 'og:description', content: 'description'},
        {property: 'og:image', content:`${this.reportImage}`},
        // {property: 'twitter:image:src', content: this.image},
        {property: 'og:image:width', content: '1000'}
      ]
    }
  },
  data() {
    return {
      strWindowFeatures:
        "location=yes,height=570,width=700,scrollbars=yes,status=yes",
      postURL: encodeURIComponent(document.location.href),
      postTitle: encodeURIComponent(
        "Solva - Evaluate the value of distributed solar and storage"
      ),
      summary: encodeURIComponent("To view the detailed report click"),
      attr: {
        facebook: "",
        instagrame: "",
        linkedin: "",
      },
    };
  },

  methods: {
    openFacebookApp() {
      this.attr.facebook = `http://www.facebook.com/sharer.php?&p[url]=https://backend.solva.in/static/${this.id}.html`;
      const URL = this.attr.facebook;
      const win = window.open(URL, "_blank", this.strWindowFeatures);
    },
    openInstaApp() {
      this.attr.instagrame = `https://twitter.com/intent/tweet?text=Solva-Report&url=https://backend.solva.in/static/${this.id}.html&hashtags=Solva-Report`;
      const URL = this.attr.instagrame;
      const win = window.open(URL, "_blank", this.strWindowFeatures);
    },
    openLinkedinApp() {
      this.attr.linkedin = `https://www.linkedin.com/sharing/share-offsite/?url=https://backend.solva.in/static/${this.id}.html`;
      const URL = this.attr.linkedin;
      const win = window.open(URL, "_blank", this.strWindowFeatures);
    },
  },
};
</script>

<style scoped>
.fixed-height {
  height: 100%;
}
.keyFindingsContanner {
  padding-left: 1pt;
  padding-right: 1pt;
}
.divWidth {
  /* max-width : 350px; */
}
.solcialMediaMenu {
  border-style: solid;
  border-width: 1px;
  border-color: #5d5e5e;
  max-width: 40pt;
  max-height: 40pt;
  border-radius: 6px;
}
.solcialMediaBar {
  max-width: 200px;
}
.col1 {
  border-style: solid;
  border-color: #64b454;
  border-width: 1px;
}
.col2 {
  border-style: solid;
  border-color: #58af79;
  border-width: 1px;
}
.col3 {
  border-style: solid;
  border-color: #339999;
  border-width: 1px;
}
.col4 {
  border-style: solid;
  border-color: #3499cc;
  border-width: 1px;
}
.pageHeadding {
  font-size: 20pt;
  color: #488539;
  font-weight: 500;
  min-height: 40pt;
  border-radius: 0;
  padding-top: 10pt;
  padding-bottom: 10pt;
  text-transform: uppercase;
}
.heading {
  font-size: 18pt;
  background-color: #64b454;
  font-weight: 400;
  min-height: 40pt;
  border-radius: 0;
}

.r2 {
  background-color: #76d35e;
}
.r3 {
  background-color: #95ee7e;
}
.r4 {
  background-color: #58af79;
}
.r5 {
  background-color: #6db389;
}
.r6 {
  background-color: #85c7a0;
}
.r7 {
  background-color: #339999;
}
.r8 {
  background-color: #4aaa98;
}
.r9 {
  background-color: #4aaa98;
}

.r10 {
  background-color: #3499cc;
}
.r11 {
  background-color: #37a5b6;
}
.r12 {
  background-color: #37a5b6;
}
.categoryContent {
  text-align: center;
  text-align: justify;
  font-size: 19pt;
  font-weight: 400;
  color: #fff;
}
/* .heading{
  margin-top: 20pt;
  margin-bottom: 20pt;
  text-align: center;
  font-size: 18pt;
  font-weight: 500;
  color:#2c7154;
} */
.btn {
  font-size: 19pt;
  font-weight: normal;
  width: 100pt;
  height: 28px;
  flex: 1 1 auto;
  padding: 30px;
  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  background-size: 200% auto;

  border-radius: 4px;
}
.btn-1 {
  background-image: linear-gradient(
    to right,
    #6bbc56 0%,
    #2fa9d8 55%,
    #2fa9d8 100%
  );
}
.v-btn:not(.v-btn--round).v-size--default {
  font-size: 19pt;
  font-weight: normal;
  color: white;
  width: 146.4518pt;
  height: 28pt;
}

.content {
  font-size: 14pt;
  font-weight: 400;
  color: #5d5e5e;
  line-height: 18.05pt;
  min-width: 100px;
}
.content-1 {
  font-size: 28pt;
  font-weight: 300;
  color: #acaeae;
  line-height: 18.05pt;
  min-width: auto;
  padding-top: 10pt;
  padding-bottom: 10pt;
}
.v-text-field--outlined >>> fieldset {
  width: 4pt;
}

.menu-border {
  border: 2px solid rgb(176, 168, 168);
  border-radius: 10px;
  margin: 0 10px;
}
</style>